import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './ScrollToTop';

const target = document.getElementById('root') as HTMLElement;
if (target) {
  const root = ReactDOM.createRoot(target);
  root.render(
    <React.StrictMode>
      <Router basename='/event'>
        <ScrollToTop />
        <App /> 
      </Router>
    </React.StrictMode>
  );
}



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
